/**
 * Constants for Tutor No-Show Management
 *
 * Timing guidelines:
 * - Initial dialog: Show immediately when student joins and tutor is absent
 * - Waiting banner: After 5 minutes of tutor absence
 * - Auto recovery: After 10 minutes, automatically search for replacement
 */

export const TUTOR_NO_SHOW = {
    // Timing delays (in minutes)
    WAITING_FROM: -15,               // a student this early starts waiting for the tutor
    INITIAL_DIALOG_DELAY: 0.1,       // ~6 seconds - show initial dialog
    WAITING_BANNER_DELAY: 5,         // 5 minutes - show waiting banner
    // 10 min (au lieu de 15) : le dispatch se déclenche plus tôt, dans une séance
    // qui commence à la même heure. Le serveur ré-ancre la recherche sur le créneau
    // de l'occurrence, donc même les bundles restés à 15 atterrissent en même-heure.
    // Miroir de LiveSession::TUTOR_ABSENCE_CLAIM_THRESHOLD_MINUTES côté serveur :
    // un client qui réclame avant ce seuil serveur prend un 422 `too_early`.
    AUTO_RECOVERY_DELAY: 10,         // 10 minutes - trigger automatic recovery

    // Modal timeouts (in seconds)
    // PRODUCTION: Should be long enough for student to read and decide
    RECOVERY_ACCEPT_TIMEOUT: 180,    // 3 minutes to accept/decline recovery session
    CREDIT_CONFIRM_TIMEOUT: 60,      // 1 minute before auto-disconnect with credit

    // Bandeau d'attente quand le tuteur termine une autre séance (sinon, celui
    // d'InformationBarComponent)
    WAITING_MESSAGE_BUSY_ELSEWHERE: "Ton tuteur termine sa séance précédente, il arrive. En attendant, travaille sur ton activité !",

    // Search window for compatible sessions (in minutes)
    SEARCH_WINDOW: 120,              // Search for sessions in next 2 hours

    // State machine states
    STATES: {
        IDLE: 'IDLE',                // No issue, tutor present or not started
        WAITING: 'WAITING',          // Tutor absent, waiting period
        SEARCHING: 'SEARCHING',      // Searching for compatible session
        PROPOSING: 'PROPOSING',      // Showing recovery session to student
        JOINING: 'JOINING',          // Student accepted, joining recovery
        CREDITING: 'CREDITING',      // No recovery or student declined, issuing credit
        DONE: 'DONE',                // Process complete
    }
}
